var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainview"},[_c('iframe',{ref:"car",staticClass:"car",attrs:{"src":_vm.url},on:{"touchstart":function($event){return _vm.console.log('down')},"mousedown":function($event){return this.$emit('down')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }